import { imagesUrl } from './constants';

const getManifestS3Url = (domain) =>
  `${imagesUrl}/eyepass/domain/${domain}/manifest/manifest.json`;

export default getManifestS3Url;
